import { render } from "./AppBreadcrumb.vue?vue&type=template&id=1c2bcd25&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=1c2bcd25&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2bcd25"]])

export default __exports__